/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React from 'react'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import style from './style'

/**
 * Text input with different style
 * @type {React.FunctionComponent}
 */

export const TextInput = props => {
  const {
    classes, // eslint-disable-line react/prop-types
    scheme,
    onChange,
    onKeyUp,
    onFocus,
    disabled,
    value,
    placeholder,
    style,
    type,
    autoFocus, // eslint-disable-line react/prop-types
    name,
    required,
    maxLength, // eslint-disable-line react/prop-types
    pattern, // eslint-disable-line react/prop-types
    className, // eslint-disable-line react/prop-types
    autoComplete
  } = props

  return (
    <input
      type={type}
      style={style}
      className={`${classes.base} ${classes[scheme]} ${className}`}
      disabled={disabled}
      onChange={onChange}
      value={value}
      autoFocus={autoFocus}
      placeholder={placeholder}
      onKeyUp={onKeyUp}
      onFocus={onFocus}
      name={name}
      pattern={pattern}
      maxLength={maxLength}
      required={required}
      autoComplete={autoComplete}
    />
  )
}

TextInput.propTypes = {
  /**
   * Available text input themes ['underline', 'full']
   */
  scheme: PropTypes.string,
  /**
   * Additional CSS style for the element
   */
  style: PropTypes.object,
  /**
   * Disable the input
   */
  disabled: PropTypes.bool,
  /**
   * Placeholder text
   */
  type: PropTypes.string,
  /**
   * type of text input ['username', 'password']
   */
  placeholder: PropTypes.string,
  /**
   * value for the text input
   */
  value: PropTypes.string,
  /**
   * Behavior of the text input onChange
   */
  onChange: PropTypes.func,
  /**
   * Behavior of the text input onFocus
   */
  onFocus: PropTypes.func,
  /**
   * Behavior of the text input onKeyUp
   */
  onKeyUp: PropTypes.func,
  /**
   * Name of input
   */
  name: PropTypes.string,
  /**
   * Is input required
   */
  required: PropTypes.bool,
  autoComplete: PropTypes.string
}

TextInput.defaultProps = {
  scheme: 'underline',
  type: 'text',
  disabled: false,
  autoFocus: false,
  onChange: () => {},
  onFocus: () => {},
  onKeyUp: () => {},
  style: {},
  required: false,
  name: ''
}

const styleAndTheme = () => style

export default injectSheet(styleAndTheme)(TextInput)
